<template>
  <div class="relative" :class="customClass">
    <slot />
  </div>
</template>

<script>
import EventBus from '@/eventBus'

export default {
  name: 'DropdownV2',
  provide() {
    return {
      dropdownV2: this,
    }
  },
  props: {
    customClass: {
      type: String,
      default: 'inline-block text-left',
    },
  },
  data() {
    return {
      isOpen: false,
      activeIndex: -1,
      items: [],
    }
  },
  mounted() {
    // Listen for global "dropdown-open" events.
    EventBus.$on('dropdown-open', (dropdownInstance) => {
      // Close this dropdown if it’s not the one that was just opened.
      if (dropdownInstance !== this) {
        this.closeDropdown()
      }
    })
    document.addEventListener('click', this.closeDropdown)
    document.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy() { // or "destroyed" in Vue 2
    EventBus.$off('dropdown-open')
    document.removeEventListener('click', this.closeDropdown)
    document.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {
    toggleDropdown() {
      // If about to open this dropdown, emit an event to close others.
      if (!this.isOpen) {
        EventBus.$emit('dropdown-open', this)
      }
      this.isOpen = !this.isOpen

      if (this.isOpen) {
        this.activeIndex = -1
      } else {
        this.$nextTick(() => {
          this.focusMenu()
        })
        this.activeIndex = -1
      }
    },
    closeDropdown() {
      this.isOpen = false
      this.activeIndex = -1
    },
    registerItem(item) {
      this.items.push(item)
    },
    unregisterItem(item) {
      const index = this.items.indexOf(item)
      if (index > -1) {
        this.items.splice(index, 1)
      }
    },
    handleKeydown(event) {
      if (!this.isOpen) return

      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault()
          if (this.activeIndex === -1) {
            this.activeIndex = 0
          } else {
            this.activeIndex = (this.activeIndex + 1) % this.items.length
          }
          break
        case 'ArrowUp':
          event.preventDefault()
          if (this.activeIndex === -1) {
            this.activeIndex = this.items.length - 1
          } else {
            this.activeIndex = (this.activeIndex - 1 + this.items.length) % this.items.length
          }
          break
        case 'Enter':
        case ' ':
          event.preventDefault()
          if (this.activeIndex !== -1) {
            this.items[this.activeIndex].$el.click()
          }
          break
        default:
          break
      }
    },
    focusMenu() {
      const menuElement = this.$el.querySelector('[role="menu"]')
      if (menuElement) {
        menuElement.focus()
      }
    },
  },
}
</script>
